import { POST_STATEROOM_DATA, POST_STATEROOM_SEARCH_DATA, POST_STATEROOM_STATUS, GET_STATEROOM_CAPACITY, GET_STATEROOM_CATEGORY, POST_STATEROOM_FILTER_DATA } from './../constants/actionTypes'
import isEmpty from 'lodash/isEmpty'

const stateroom = (store = {}, action = {}) => {
  if (action.type === POST_STATEROOM_DATA) {
    return action.data.data.staterooms
  } else {
    return store
  }
}

const stateroomCategory = (store = {}, action = {}) => {
  if (action.type === GET_STATEROOM_CATEGORY) {
    return action.data.data
  } else {
    return store
  }
}
const stateroomCapacity = (store = {}, action = {}) => {
  if (action.type === GET_STATEROOM_CAPACITY) {
    return action.data.data
  } else {
    return store
  }
}
const stateroomStatus = (store = {}, action = {}) => {
  if (action.type === POST_STATEROOM_STATUS) {
    return action.data
  } else {
    return store
  }
}

const searchedStateroom = (store = [], action = {}) => {
  if (action.type === POST_STATEROOM_SEARCH_DATA) {
    let apiResponse = []
    apiResponse = action.data
    let stateData = store
    let stateroomList = {}
    if (isEmpty(stateData)) {
      stateroomList = { ...apiResponse }
    } else if (!isEmpty(apiResponse) && apiResponse._embedded) {
      stateroomList = {
        ...stateData,
        _embedded: {
          staterooms: [
            ...stateData._embedded.staterooms,
            ...apiResponse._embedded.staterooms
          ]
        }
      }
    } else {
      stateroomList = { ...stateData }
    }
    return stateroomList
  } else if (action.type === POST_STATEROOM_FILTER_DATA) {
    if (!(action.data.data && action.data.data._embedded)) {
      return []
    }
    let apiResponse = action.data.data
    let stateroomList = {
      ...apiResponse
    }
    return stateroomList
  } else {
    return store
  }
}

export { stateroom, searchedStateroom, stateroomStatus, stateroomCategory, stateroomCapacity }
